<template>
  <div v-if="loaded" class="qa-lib">
    <div class="tiku-content">
      <breadcrumb :title="courseName" :font-size="fontSize" @enlarge-text="enlargeText" />

      <div class="tiku__bd">
        <div class="tiku__bd__inner">
          <!-- 题目列表 -->
          <div class="question-list">
            <template v-for="(item, index) of list">
              <div class="question-wrapper" v-show="index === currentIndex" :key="item.questionId">
                <question
                  :style="{ fontSize: fontSize }"
                  :id="item.questionId"
                  :type="item.questionOptionType"
                  :title="`${index + 1}、${item.name}`"
                  :options="item.optionsName"
                  :is-fav="!!item.isFav"
                  :my-answer="myAnswers[item.questionId]"
                  @select="updateMyAnswers"
                  @fav="addFavorite"
                  @unfav="cancelFavorite"
                  @feedback="feedback"
                  hide-mark
                />

                <!-- 解析、答疑、笔记 -->
                <question-tabs
                  active="qa"
                  :question="item"
                  :my-answer="myAnswers[item.questionId]"
                  is-my
                />
              </div>
            </template>
          </div>
        </div>
      </div>

      <pre-next :index="currentIndex" :total="total" @prev="onPrev" @next="onNext" />
    </div>

    <div class="tiku-sidebar">
      <exam-tool title="问答库" :num="currentIndex + 1" :total="total" @back="toTikuQa" />
    </div>
  </div>
</template>

<script>
import tikuMixin from '@/mixins/tiku';
import PreNext from '@/components/pre-next/index.vue';
import { COURSENAME } from '@/config/course';
import Breadcrumb from '../breadcrumb.vue';
import ExamTool from '../exam-tool.vue';
import Question from '../question.vue';
import QuestionTabs from '../question-tabs.vue';

export default {
  name: 'QaLib',
  mixins: [tikuMixin],
  components: {
    PreNext,
    Breadcrumb,
    ExamTool,
    Question,
    QuestionTabs,
  },
  computed: {
    courseName() {
      return COURSENAME[this.$route.params.courseId];
    },
  },
  created() {
    const loading = this.$loading();
    this.$api.tiku
      .getAllQuestionOfQA(this.$route.params.courseId)
      .then((res) => {
        this.list = res || [];
        this.initQuestionData();
        this.loaded = true;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        loading.close();
      });
  },
  methods: {
    toTikuQa() {
      this.$router.push({
        name: 'TikuQuestion',
        params: {
          courseId: this.$route.params.courseId,
        },
      });
    },
  },
};
</script>
